// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* =====================================================
   Base = MOBILE (360px+): single column, mobile-first
   ===================================================== */
.impac_trac_ho_pg_section {
  position: relative;
  width: 100%;
  padding: 48px 0 56px;
  background-color: #ffffff;
  font-family: "Sora", sans-serif;
}

.impac_trac_ho_pg_section *,
.impac_trac_ho_pg_section *::before,
.impac_trac_ho_pg_section *::after {
  box-sizing: border-box;
}

.impac_trac_ho_pg_container {
  width: 100%;
  max-width: 1280px;
  margin: 0 auto;
  padding: 0 20px;
}

/* ===== Fade animation ===== */
.impac_trac_ho_pg_fade {
  opacity: 0;
  transform: translateY(26px);
  transition: opacity 0.8s ease-out, transform 0.8s ease-out;
}

.impac_trac_ho_pg_fade_show {
  opacity: 1;
  transform: translateY(0);
}

/* ===== Heading ===== */
.impac_trac_ho_pg_title {
  margin: 0;
  font-size: 1.5rem;
  font-weight: 800;
  line-height: 1.25;
  letter-spacing: -0.5px;
  color: #1c1c1c;
}

.impac_trac_ho_pg_title_line {
  display: block;
}

.impac_trac_ho_pg_line_box {
  margin: 14px 0 0;
}

.impac_trac_ho_pg_line_bar {
  display: block;
  width: 0;
  height: 2px;
  border-radius: 2px;
  background-color: #1c1c1c;
  transition: width 0.9s ease 0.2s;
}

.impac_trac_ho_pg_fade_show .impac_trac_ho_pg_line_bar {
  width: 56px;
}

/* ===== Cards ===== */
.impac_trac_ho_pg_cards {
  display: grid;
  grid-template-columns: 1fr;
  gap: 16px;
  margin-top: 30px;
}

.impac_trac_ho_pg_card_wrap {
  display: flex;
}

.impac_trac_ho_pg_card {
  position: relative;
  isolation: isolate;
  flex: 1 1 auto;
  padding: 22px;
  overflow: hidden;
  border: 1px solid #ece8f5;
  border-radius: 16px;
  background-color: #ffffff;
  transition: transform 0.4s ease, box-shadow 0.4s ease,
    border-color 0.4s ease;
}

.impac_trac_ho_pg_card_accent {
  border-color: #e9defb;
  background-color: #f5f1fd;
}

/* purple layer: fades in on hover */
.impac_trac_ho_pg_card::before {
  content: "";
  position: absolute;
  inset: 0;
  z-index: -1;
  background: linear-gradient(135deg, #5b21b6 0%, #8e0fc9 100%);
  opacity: 0;
  transition: opacity 0.45s ease;
}

/* shine that sweeps across on hover */
.impac_trac_ho_pg_card::after {
  content: "";
  position: absolute;
  top: 0;
  left: -60%;
  z-index: -1;
  width: 40%;
  height: 100%;
  background: linear-gradient(
    100deg,
    rgba(255, 255, 255, 0) 0%,
    rgba(255, 255, 255, 0.28) 50%,
    rgba(255, 255, 255, 0) 100%
  );
  transform: skewX(-18deg);
  transition: left 0.8s ease;
}

.impac_trac_ho_pg_card_label {
  margin: 0;
  font-size: 0.66rem;
  font-weight: 800;
  letter-spacing: 1.2px;
  text-transform: uppercase;
  color: #5a5a66;
  transition: color 0.35s ease;
}

.impac_trac_ho_pg_card_accent .impac_trac_ho_pg_card_label {
  color: #5b2fc0;
}

.impac_trac_ho_pg_card_title {
  margin: 14px 0 0;
  font-size: 2rem;
  font-weight: 800;
  line-height: 1.1;
  letter-spacing: -0.5px;
  color: #6b6b7a;
  transition: color 0.35s ease;
}

.impac_trac_ho_pg_card_accent .impac_trac_ho_pg_card_title {
  color: #4a1fa8;
}

.impac_trac_ho_pg_list {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin: 18px 0 0;
  padding: 0;
  list-style: none;
}

.impac_trac_ho_pg_item {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  font-size: 0.88rem;
  font-weight: 500;
  line-height: 1.5;
  color: #444444;
  opacity: 0;
  transform: translateX(-12px);
  transition: opacity 0.6s ease, transform 0.6s ease, color 0.35s ease;
}

.impac_trac_ho_pg_card_accent .impac_trac_ho_pg_item {
  color: #333333;
}

.impac_trac_ho_pg_fade_show .impac_trac_ho_pg_item {
  opacity: 1;
  transform: translateX(0);
}

.impac_trac_ho_pg_check {
  display: inline-flex;
  flex: 0 0 auto;
  margin-top: 5px;
  color: #4a1fa8;
  transition: color 0.35s ease;
}

/* ===== Card hover: turns purple ===== */
.impac_trac_ho_pg_card:hover {
  transform: translateY(-8px);
  border-color: transparent;
  box-shadow: 0 22px 44px rgba(91, 33, 182, 0.32);
}

.impac_trac_ho_pg_card:hover::before {
  opacity: 1;
}

.impac_trac_ho_pg_card:hover::after {
  left: 130%;
}

.impac_trac_ho_pg_card:hover .impac_trac_ho_pg_card_label {
  color: rgba(255, 255, 255, 0.85);
}

.impac_trac_ho_pg_card:hover .impac_trac_ho_pg_card_title,
.impac_trac_ho_pg_card:hover .impac_trac_ho_pg_item,
.impac_trac_ho_pg_card:hover .impac_trac_ho_pg_check {
  color: #ffffff;
}

.impac_trac_ho_pg_card:hover .impac_trac_ho_pg_check {
  animation: impac_trac_ho_pg_pop 0.5s ease;
}

@keyframes impac_trac_ho_pg_pop {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.5);
  }
  100% {
    transform: scale(1);
  }
}



/* ===== 360px Android and small phones ===== */
@media (max-width: 360px) {
  .impac_trac_ho_pg_section {
    padding: 40px 0 48px;
  }

  .impac_trac_ho_pg_container {
    padding: 0 16px;
  }

  .impac_trac_ho_pg_title {
    font-size: 1.35rem;
  }

  .impac_trac_ho_pg_card {
    padding: 18px;
  }

  .impac_trac_ho_pg_card_title {
    font-size: 1.8rem;
  }

  .impac_trac_ho_pg_item {
    font-size: 0.84rem;
  }
}

/* ===== Large phones ===== */
@media (min-width: 600px) {
  .impac_trac_ho_pg_section {
    padding: 60px 0 68px;
  }

  .impac_trac_ho_pg_container {
    padding: 0 32px;
  }

  .impac_trac_ho_pg_title {
    font-size: 2rem;
  }

  .impac_trac_ho_pg_card {
    padding: 26px;
  }

  .impac_trac_ho_pg_item {
    font-size: 0.95rem;
  }

 
}

/* ===== Tablets: cards side by side, bridge in one row ===== */
@media (min-width: 768px) {
  .impac_trac_ho_pg_title {
    font-size: 2.2rem;
  }

  .impac_trac_ho_pg_cards {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 20px;
    margin-top: 40px;
  }

  .impac_trac_ho_pg_card {
    padding: 26px 24px;
  }

  .impac_trac_ho_pg_card_title {
    font-size: 2.3rem;
  }

  .impac_trac_ho_pg_item {
    font-size: 0.86rem;
  }

  
}

/* ===== Laptops ===== */
@media (min-width: 1024px) {
  .impac_trac_ho_pg_section {
    padding: 72px 0 80px;
  }

  .impac_trac_ho_pg_container {
    padding: 0 48px;
  }

  .impac_trac_ho_pg_title {
    font-size: 2.6rem;
  }

  .impac_trac_ho_pg_cards {
    gap: 24px;
    margin-top: 48px;
  }

  .impac_trac_ho_pg_card {
    padding: 32px 34px;
  }

  .impac_trac_ho_pg_card_title {
    font-size: 2.5rem;
  }

  .impac_trac_ho_pg_item {
    font-size: 0.95rem;
  }

 
}

/* ===== Desktop ===== */
@media (min-width: 1200px) {
  .impac_trac_ho_pg_title {
    font-size: 2.9rem;
  }

  .impac_trac_ho_pg_card_title {
    font-size: 2.7rem;
  }

  .impac_trac_ho_pg_card_label {
    font-size: 0.7rem;
  }

 
}

/* ===== Large screens ===== */
@media (min-width: 1600px) {
  .impac_trac_ho_pg_container {
    max-width: 1440px;
  }

  .impac_trac_ho_pg_title {
    font-size: 3.3rem;
  }

  .impac_trac_ho_pg_card {
    padding: 40px 42px;
  }

  .impac_trac_ho_pg_card_title {
    font-size: 3rem;
  }

  .impac_trac_ho_pg_item {
    font-size: 1.05rem;
  }
}

/* ===== Reduced motion: no fade / no movement ===== */
@media (prefers-reduced-motion: reduce) {
  .impac_trac_ho_pg_fade,
  .impac_trac_ho_pg_item {
    opacity: 1;
    transform: none;
    transition: none;
  }

  .impac_trac_ho_pg_line_bar {
    width: 56px;
    transition: none;
  }

  .impac_trac_ho_pg_card,
  .impac_trac_ho_pg_card::before,
  .impac_trac_ho_pg_card::after {
    transition-duration: 0.01ms !important;
  }

  .impac_trac_ho_pg_card:hover .impac_trac_ho_pg_check {
    animation: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/Components/HomeTrackPage/HomeTrackPage.css"],"names":[],"mappings":"AAAA;;0DAE0D;AAC1D;EACE,kBAAkB;EAClB,WAAW;EACX,oBAAoB;EACpB,yBAAyB;EACzB,+BAA+B;AACjC;;AAEA;;;EAGE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA,+BAA+B;AAC/B;EACE,UAAU;EACV,2BAA2B;EAC3B,0DAA0D;AAC5D;;AAEA;EACE,UAAU;EACV,wBAAwB;AAC1B;;AAEA,wBAAwB;AACxB;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,QAAQ;EACR,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,WAAW;AACb;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,0BAA0B;EAC1B,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,yBAAyB;EACzB;0BACwB;AAC1B;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA,oCAAoC;AACpC;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,6DAA6D;EAC7D,UAAU;EACV,8BAA8B;AAChC;;AAEA,sCAAsC;AACtC;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,UAAU;EACV,WAAW;EACX,UAAU;EACV,YAAY;EACZ;;;;;GAKC;EACD,wBAAwB;EACxB,0BAA0B;AAC5B;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;EAChB,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,UAAU;EACV,4BAA4B;EAC5B,oEAAoE;AACtE;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,eAAe;EACf,cAAc;EACd,4BAA4B;AAC9B;;AAEA,yCAAyC;AACzC;EACE,2BAA2B;EAC3B,yBAAyB;EACzB,+CAA+C;AACjD;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,gCAAgC;AAClC;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE;IACE,mBAAmB;EACrB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,mBAAmB;EACrB;AACF;;;;AAIA,+CAA+C;AAC/C;EACE;IACE,oBAAoB;EACtB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA,6BAA6B;AAC7B;EACE;IACE,oBAAoB;EACtB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;;;AAGF;;AAEA,+DAA+D;AAC/D;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,gDAAgD;IAChD,SAAS;IACT,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;;AAGF;;AAEA,wBAAwB;AACxB;EACE;IACE,oBAAoB;EACtB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,SAAS;IACT,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;;AAGF;;AAEA,wBAAwB;AACxB;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;;AAGF;;AAEA,8BAA8B;AAC9B;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA,sDAAsD;AACtD;EACE;;IAEE,UAAU;IACV,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,gBAAgB;EAClB;;EAEA;;;IAGE,sCAAsC;EACxC;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":["/* =====================================================\n   Base = MOBILE (360px+): single column, mobile-first\n   ===================================================== */\n.impac_trac_ho_pg_section {\n  position: relative;\n  width: 100%;\n  padding: 48px 0 56px;\n  background-color: #ffffff;\n  font-family: \"Sora\", sans-serif;\n}\n\n.impac_trac_ho_pg_section *,\n.impac_trac_ho_pg_section *::before,\n.impac_trac_ho_pg_section *::after {\n  box-sizing: border-box;\n}\n\n.impac_trac_ho_pg_container {\n  width: 100%;\n  max-width: 1280px;\n  margin: 0 auto;\n  padding: 0 20px;\n}\n\n/* ===== Fade animation ===== */\n.impac_trac_ho_pg_fade {\n  opacity: 0;\n  transform: translateY(26px);\n  transition: opacity 0.8s ease-out, transform 0.8s ease-out;\n}\n\n.impac_trac_ho_pg_fade_show {\n  opacity: 1;\n  transform: translateY(0);\n}\n\n/* ===== Heading ===== */\n.impac_trac_ho_pg_title {\n  margin: 0;\n  font-size: 1.5rem;\n  font-weight: 800;\n  line-height: 1.25;\n  letter-spacing: -0.5px;\n  color: #1c1c1c;\n}\n\n.impac_trac_ho_pg_title_line {\n  display: block;\n}\n\n.impac_trac_ho_pg_line_box {\n  margin: 14px 0 0;\n}\n\n.impac_trac_ho_pg_line_bar {\n  display: block;\n  width: 0;\n  height: 2px;\n  border-radius: 2px;\n  background-color: #1c1c1c;\n  transition: width 0.9s ease 0.2s;\n}\n\n.impac_trac_ho_pg_fade_show .impac_trac_ho_pg_line_bar {\n  width: 56px;\n}\n\n/* ===== Cards ===== */\n.impac_trac_ho_pg_cards {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 16px;\n  margin-top: 30px;\n}\n\n.impac_trac_ho_pg_card_wrap {\n  display: flex;\n}\n\n.impac_trac_ho_pg_card {\n  position: relative;\n  isolation: isolate;\n  flex: 1 1 auto;\n  padding: 22px;\n  overflow: hidden;\n  border: 1px solid #ece8f5;\n  border-radius: 16px;\n  background-color: #ffffff;\n  transition: transform 0.4s ease, box-shadow 0.4s ease,\n    border-color 0.4s ease;\n}\n\n.impac_trac_ho_pg_card_accent {\n  border-color: #e9defb;\n  background-color: #f5f1fd;\n}\n\n/* purple layer: fades in on hover */\n.impac_trac_ho_pg_card::before {\n  content: \"\";\n  position: absolute;\n  inset: 0;\n  z-index: -1;\n  background: linear-gradient(135deg, #5b21b6 0%, #8e0fc9 100%);\n  opacity: 0;\n  transition: opacity 0.45s ease;\n}\n\n/* shine that sweeps across on hover */\n.impac_trac_ho_pg_card::after {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: -60%;\n  z-index: -1;\n  width: 40%;\n  height: 100%;\n  background: linear-gradient(\n    100deg,\n    rgba(255, 255, 255, 0) 0%,\n    rgba(255, 255, 255, 0.28) 50%,\n    rgba(255, 255, 255, 0) 100%\n  );\n  transform: skewX(-18deg);\n  transition: left 0.8s ease;\n}\n\n.impac_trac_ho_pg_card_label {\n  margin: 0;\n  font-size: 0.66rem;\n  font-weight: 800;\n  letter-spacing: 1.2px;\n  text-transform: uppercase;\n  color: #5a5a66;\n  transition: color 0.35s ease;\n}\n\n.impac_trac_ho_pg_card_accent .impac_trac_ho_pg_card_label {\n  color: #5b2fc0;\n}\n\n.impac_trac_ho_pg_card_title {\n  margin: 14px 0 0;\n  font-size: 2rem;\n  font-weight: 800;\n  line-height: 1.1;\n  letter-spacing: -0.5px;\n  color: #6b6b7a;\n  transition: color 0.35s ease;\n}\n\n.impac_trac_ho_pg_card_accent .impac_trac_ho_pg_card_title {\n  color: #4a1fa8;\n}\n\n.impac_trac_ho_pg_list {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  margin: 18px 0 0;\n  padding: 0;\n  list-style: none;\n}\n\n.impac_trac_ho_pg_item {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  font-size: 0.88rem;\n  font-weight: 500;\n  line-height: 1.5;\n  color: #444444;\n  opacity: 0;\n  transform: translateX(-12px);\n  transition: opacity 0.6s ease, transform 0.6s ease, color 0.35s ease;\n}\n\n.impac_trac_ho_pg_card_accent .impac_trac_ho_pg_item {\n  color: #333333;\n}\n\n.impac_trac_ho_pg_fade_show .impac_trac_ho_pg_item {\n  opacity: 1;\n  transform: translateX(0);\n}\n\n.impac_trac_ho_pg_check {\n  display: inline-flex;\n  flex: 0 0 auto;\n  margin-top: 5px;\n  color: #4a1fa8;\n  transition: color 0.35s ease;\n}\n\n/* ===== Card hover: turns purple ===== */\n.impac_trac_ho_pg_card:hover {\n  transform: translateY(-8px);\n  border-color: transparent;\n  box-shadow: 0 22px 44px rgba(91, 33, 182, 0.32);\n}\n\n.impac_trac_ho_pg_card:hover::before {\n  opacity: 1;\n}\n\n.impac_trac_ho_pg_card:hover::after {\n  left: 130%;\n}\n\n.impac_trac_ho_pg_card:hover .impac_trac_ho_pg_card_label {\n  color: rgba(255, 255, 255, 0.85);\n}\n\n.impac_trac_ho_pg_card:hover .impac_trac_ho_pg_card_title,\n.impac_trac_ho_pg_card:hover .impac_trac_ho_pg_item,\n.impac_trac_ho_pg_card:hover .impac_trac_ho_pg_check {\n  color: #ffffff;\n}\n\n.impac_trac_ho_pg_card:hover .impac_trac_ho_pg_check {\n  animation: impac_trac_ho_pg_pop 0.5s ease;\n}\n\n@keyframes impac_trac_ho_pg_pop {\n  0% {\n    transform: scale(1);\n  }\n  50% {\n    transform: scale(1.5);\n  }\n  100% {\n    transform: scale(1);\n  }\n}\n\n\n\n/* ===== 360px Android and small phones ===== */\n@media (max-width: 360px) {\n  .impac_trac_ho_pg_section {\n    padding: 40px 0 48px;\n  }\n\n  .impac_trac_ho_pg_container {\n    padding: 0 16px;\n  }\n\n  .impac_trac_ho_pg_title {\n    font-size: 1.35rem;\n  }\n\n  .impac_trac_ho_pg_card {\n    padding: 18px;\n  }\n\n  .impac_trac_ho_pg_card_title {\n    font-size: 1.8rem;\n  }\n\n  .impac_trac_ho_pg_item {\n    font-size: 0.84rem;\n  }\n}\n\n/* ===== Large phones ===== */\n@media (min-width: 600px) {\n  .impac_trac_ho_pg_section {\n    padding: 60px 0 68px;\n  }\n\n  .impac_trac_ho_pg_container {\n    padding: 0 32px;\n  }\n\n  .impac_trac_ho_pg_title {\n    font-size: 2rem;\n  }\n\n  .impac_trac_ho_pg_card {\n    padding: 26px;\n  }\n\n  .impac_trac_ho_pg_item {\n    font-size: 0.95rem;\n  }\n\n \n}\n\n/* ===== Tablets: cards side by side, bridge in one row ===== */\n@media (min-width: 768px) {\n  .impac_trac_ho_pg_title {\n    font-size: 2.2rem;\n  }\n\n  .impac_trac_ho_pg_cards {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    gap: 20px;\n    margin-top: 40px;\n  }\n\n  .impac_trac_ho_pg_card {\n    padding: 26px 24px;\n  }\n\n  .impac_trac_ho_pg_card_title {\n    font-size: 2.3rem;\n  }\n\n  .impac_trac_ho_pg_item {\n    font-size: 0.86rem;\n  }\n\n  \n}\n\n/* ===== Laptops ===== */\n@media (min-width: 1024px) {\n  .impac_trac_ho_pg_section {\n    padding: 72px 0 80px;\n  }\n\n  .impac_trac_ho_pg_container {\n    padding: 0 48px;\n  }\n\n  .impac_trac_ho_pg_title {\n    font-size: 2.6rem;\n  }\n\n  .impac_trac_ho_pg_cards {\n    gap: 24px;\n    margin-top: 48px;\n  }\n\n  .impac_trac_ho_pg_card {\n    padding: 32px 34px;\n  }\n\n  .impac_trac_ho_pg_card_title {\n    font-size: 2.5rem;\n  }\n\n  .impac_trac_ho_pg_item {\n    font-size: 0.95rem;\n  }\n\n \n}\n\n/* ===== Desktop ===== */\n@media (min-width: 1200px) {\n  .impac_trac_ho_pg_title {\n    font-size: 2.9rem;\n  }\n\n  .impac_trac_ho_pg_card_title {\n    font-size: 2.7rem;\n  }\n\n  .impac_trac_ho_pg_card_label {\n    font-size: 0.7rem;\n  }\n\n \n}\n\n/* ===== Large screens ===== */\n@media (min-width: 1600px) {\n  .impac_trac_ho_pg_container {\n    max-width: 1440px;\n  }\n\n  .impac_trac_ho_pg_title {\n    font-size: 3.3rem;\n  }\n\n  .impac_trac_ho_pg_card {\n    padding: 40px 42px;\n  }\n\n  .impac_trac_ho_pg_card_title {\n    font-size: 3rem;\n  }\n\n  .impac_trac_ho_pg_item {\n    font-size: 1.05rem;\n  }\n}\n\n/* ===== Reduced motion: no fade / no movement ===== */\n@media (prefers-reduced-motion: reduce) {\n  .impac_trac_ho_pg_fade,\n  .impac_trac_ho_pg_item {\n    opacity: 1;\n    transform: none;\n    transition: none;\n  }\n\n  .impac_trac_ho_pg_line_bar {\n    width: 56px;\n    transition: none;\n  }\n\n  .impac_trac_ho_pg_card,\n  .impac_trac_ho_pg_card::before,\n  .impac_trac_ho_pg_card::after {\n    transition-duration: 0.01ms !important;\n  }\n\n  .impac_trac_ho_pg_card:hover .impac_trac_ho_pg_check {\n    animation: none;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
